module.exports = __webpack_public_path__ + "static/media/player_background.540ab683.jpg";